import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { getFilters } from 'features/resultFiltering/resultFilteringSlice';
import {
  SearchResultsGroup,
  SearchResultsGroupMember,
} from 'features/searchMolecules/searchMoleculesSlice';
import { CartMember } from 'features/shoppingCart/shoppingCartSlice';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ResultGroupMemberView from './ResultGroupMemberView';
import { inFilter } from './utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    noMembers: { marginTop: theme.spacing(4) },
    wrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(11rem, 1fr))',
      gridGap: '1rem',
      overFlow: 'auto',
      padding: '1rem',
    },
  }),
);

interface Props {
  groupMembers: SearchResultsGroupMember[];
  resultGroups: SearchResultsGroup[];
  cartItems: CartMember[];
  refmol: string;
  calcs: { [key: string]: string };
  loadAsQuery: (smiles: string) => void;
}

const ResultGroupContentView = ({
  groupMembers,
  resultGroups,
  refmol,
  calcs,
  cartItems,
  loadAsQuery,
}: Readonly<Props>) => {
  const classes = useStyles();
  const { t } = useTranslation(['common', 'results']);
  const filters = useSelector(getFilters);

  const filteredResults = groupMembers.filter((member) => inFilter(member, filters));
  const numberOfMembersLeft = resultGroups
    .map((group) => group.members)
    .flat()
    .filter((member) => inFilter(member, filters)).length;

  return filteredResults.length ? (
    <div className={classes.wrapper}>
      {filteredResults.map((member, idx) => (
        <ResultGroupMemberView
          cartItems={cartItems}
          key={`group-member-${idx}`}
          groupMember={member}
          refmol={refmol}
          calcs={calcs}
          loadAsQuery={loadAsQuery}
        />
      ))}
    </div>
  ) : (
    <>
      <Typography className={classes.noMembers} variant="h6">
        {t('results:no_members_left_0')}
      </Typography>
      <Typography variant="subtitle1">
        {t('results:no_members_left_1') + `${numberOfMembersLeft}` + t('results:no_members_left_2')}
      </Typography>
    </>
  );
};

export default ResultGroupContentView;
